/**
 * Flattens Django REST Framework-style error payloads into string values per form key.
 * Use `submit` for non-field errors, detail, and message.
 */
const FIELD_ALIASES = {
  password_confirm: "passwordConfirm",
  username: "email",
};

function joinMessages(value) {
  if (value == null) return "";
  if (Array.isArray(value)) {
    return value.filter(Boolean).map(String).join(" ").trim();
  }
  return String(value).trim();
}

export function normalizeAuthApiErrors(data) {
  if (data == null || typeof data !== "object") {
    return {
      submit: "Something went wrong. Please try again.",
    };
  }

  const out = {};

  const addGeneral = (value) => {
    const text = joinMessages(value);
    if (!text) return;
    out.submit = out.submit ? `${out.submit} ${text}` : text;
  };

  if (data.detail != null) {
    addGeneral(data.detail);
  }
  if (data.message) {
    addGeneral(data.message);
  }
  if (Array.isArray(data.non_field_errors)) {
    addGeneral(data.non_field_errors);
  }

  for (const key of Object.keys(data)) {
    if (key === "detail" || key === "message" || key === "non_field_errors") {
      continue;
    }
    const text = joinMessages(data[key]);
    if (text) {
      out[key] = text;
    }
  }

  const mapped = {};
  for (const [key, value] of Object.entries(out)) {
    const formKey = FIELD_ALIASES[key] || key;
    if (mapped[formKey] && formKey !== "submit") {
      mapped[formKey] = `${mapped[formKey]} ${value}`;
    } else {
      mapped[formKey] = value;
    }
  }

  return mapped;
}
